export default function ({ $auth, redirect }) {
    if (!['Admin', 'Super-Admin'].includes($auth.user.role.name)) {
        return redirect('/');
    }
}
